export default "__VITE_ASSET__CWXVVo2X__"